
export const ReadinessGapLevel = (score) => {
  if (score < 40) {
    return 3
  } else if (score < 75) {
    return 2
  } else  {
    return 1
  }
}

export const ReadinessEdRequirement = (level) => {
  switch(level) {
    case level.match(/high/):
      return 'helpful'
    case level.match(/bach/):
      return 'important'
    case level.match(/(mast|doc)/):
      return 'necessary'
    default:
      return 'helpful'
  }
}

export const ReadinessSoftSkillRequirement = (score) => {
  if(score < 20) {
    return 'helpful'
  } else if(score < 50) {
    return 'important'
  } else {
    return 'necessary'
  }
}

export const ReadinessHardSkillRequirement = (score) => {
  if(score < 15) {
    return 'helpful'
  } else if(score < 30) {
    return 'important'
  } else {
    return 'necessary'
  }
}

const ReadinessBreakpoint = (score) => {
  if(score < 40) {
    return 'warning'
  } else if (score < 75) {
    return 'mild'
  } else {
    return 'good'
  }
}

export default ReadinessBreakpoint;
